import { render, staticRenderFns } from "./UnusualOrders.vue?vue&type=template&id=7bb49a46&scoped=true&"
import script from "./UnusualOrders.vue?vue&type=script&lang=js&"
export * from "./UnusualOrders.vue?vue&type=script&lang=js&"
import style0 from "./UnusualOrders.vue?vue&type=style&index=0&id=7bb49a46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb49a46",
  null
  
)

export default component.exports